import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "font-semibold text-white text-xl leading-[24px] select-none"
}

import LoaderIcon from "@/components/icons/LoaderIcon.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmButton',
  props: {
    disabled: { type: Boolean },
    loading: { type: Boolean },
    buttonText: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["w-full h-14 mb-4 rounded-full bg-orange-gradient", {
      'opacity-40 pointer-events-none': __props.disabled,
    }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, [
    (__props.loading)
      ? (_openBlock(), _createBlock(LoaderIcon, { key: 0 }))
      : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.buttonText), 1))
  ], 2))
}
}

})